export default "__VITE_ASSET__C1CyCQU8__"